<template>
  <div>
    <h3 class="font-semibold leading-6 mb-4 text-init mt-0">
      Style
    </h3>
    <BaseChipSelector
      :model-value="selectedValues"
      class="flex-wrap"
      :options="chipOptions"
      data-test-id="more__filters-style-section"
      @change="onChange"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

import BaseChipSelector from '@/components/Ui/Forms/BaseChipSelector.vue';
import searchOptions from '@/modules/public/search/store/options.json';

const emit = defineEmits(['change']);

const store = useStore();

const chipValue = (option) => `${option.param}-${option.id}`;

const chipOptions = searchOptions.styleOptions.map((option) => ({
  ...option,
  value: chipValue(option),
}));

// String comparison: room tag ids hydrated from the URL can be strings.
const isOptionSelected = (option) => store.state.filters.roomTags.value
  .some((id) => String(id) === String(option.id));

const selectedValues = computed(() => chipOptions
  .filter(isOptionSelected)
  .map((option) => option.value));

const onChange = (value, isSelected) => {
  const option = chipOptions.find((chip) => chip.value === value);
  emit('change', { field: option.param, key: option.id, value: isSelected });
};
</script>
